module.exports = __webpack_public_path__ + "img/c3a0e.8f70b9ef.png";